export enum BillingPeriod {
    NO_BILLING_PERIOD = "One Time",
    DAILY = "Daily",
    WEEKLY = "Weekly",
    BIWEEKLY = "Bi-Weekly",
    MONTHLY = "Monthly",
    QUARTERLY = "Quarterly",
    BIANNUAL = "Biannual",
    ANNUAL = "Annual"
}

export enum Duration {
    DAYS = "Days",
    WEEKS = "Weeks",
    MONTHS = "Months",
    YEARS = "Years",
    UNLIMITED = "Unlimited"
}

export enum BillingCycle {
    ONCE = "once",
    EACH = "each",
    MONTHLY = "monthly",
    YEARLY = "yearly",
}

export enum Currency {
    EUR = "EUR",
    USD = "USD"
}

export enum Termination {
    NEVER = "never",
    DAY = "day",
    WEEK = "week",
    MONTH = "month",
    YEAR = "year"
}

export enum UnitValue {
    API_CALLS = "api_calls",
    LICENSE_FEE = "license_fee",
    SETUP_FEE = "setup_fee",
    USAGE_FEE = "usage_fee",
    USER = "user",
}

export enum PhaseCycle {
    INITIAL = "INITIAL",
    FINAL = "FINAL"
}

export enum BillingMode {
    IN_ARREAR = "In Arrear",
    IN_ADVANCE = "In Advance",
}

export enum Policy {
    TOP_TIER = "TOP_TIER",
    ALL_TIERS = "ALL_TIERS",
}

/**
 * @todo implement description
 * @todo implement public as boolean value (default true)
 */
export interface Plan {
    plan_id: string;
    name: string;
    rank: number;
    description?: string;
    public: boolean;
    active: boolean;
    currency: string;
    published?: boolean;
    state?: any;
    phases: Phase[];
    rules: unknown[]
}

export interface Phase {
    name?: string,
    phase_cycle: PhaseCycle,
    duration: {
        duration_unit?: Duration.UNLIMITED,
        duration_value?: number
    },
    rank?: number,
    plan_components?: PlanComponent[];
}

export enum PlanComponentTypes {
    one_time = "one_time",
    time_based_only = "time_based_only",
    usage_based_only = "usage_based_only"
}

/**
 * @todo implement rank
 */
export interface PlanComponent {
    plan_component_id: string,
    one_time: {
        name?: string;
        price?: number;
        billing_period?: BillingPeriod;
        billing_mode?: BillingMode.IN_ARREAR;
    },
    time_based_only: {
        name?: string;
        price?: number;
        billing_period?: BillingPeriod;
        billing_mode?: BillingMode.IN_ARREAR;
    },
    usage_based_only: {
        consumption?: {
            name: string;
            policy: string;
            billing_period: BillingPeriod;
            billing_mode: string;
            isRecurring?: boolean;
            tiers: TierConsumption[];
            peak_consumption: boolean;
            carry_units: boolean;
        },
        capacity?: {
            name: string;
            billing_period: string;
            tiers: TierCapacity[];
            isRecurring?: boolean;
        }
    },
    minimum_term: {
        duration_unit: Duration;
        duration_value: number;
    },
    notice_period: {
        duration_unit: Duration;
        duration_value: number;
    },
    termination: {
        duration: {
            duration_unit: Duration;
            duration_value: number;
        },
        authoritative: boolean;
    },
    rules: unknown[];
}

export interface TierConsumption {
    tier_id: string;
    tier_name: string;
    size: number;
    limit: TierLimit,
    price: number;
    recurring?: boolean;
}

export interface TierCapacity {
    tier_id: string;
    tier_name: string;
    size: number;
    limits: TierLimit[],
    price: number;
    recurring?: boolean;
}

export interface TierLimit {
    max_value: number;
    unit: string;
}

export enum PlanTypes {
    TIME_BOUND = "time_bound",
    MEASURABLE = "measurable",
    TIME_BOUND_AND_MEASURABLE = "time_bound_and_measurable"
}

export enum UsageTypes {
    CONSUMPTION = "consumption",
    CAPACITY = "capacity"
}

export interface State {
    q1: PlanTypes,
    q2: {
        unit: string,
        price?: number,
        billing_period?: BillingPeriod
    },
    q3: {
        unit?: string,
    },
    q4: {
        pay_per_unit: boolean
    }
    q5: {
        billing_period?: BillingPeriod,
        multi_tier?: boolean,
        plan_components?: StatePlanComponent[],
    },
    q6: unknown
}

export interface StatePlanComponent {
    isRecurring?: boolean,
    price: number,
    size?: number,
    tier_name?: string,
    unit: string,
    billing_period?: string
}